import { useState, useEffect } from "react";
import hero from "../assets/images/hero.png";
import logo from "../assets/images/logo.png";
import { Link } from "react-router-dom";
import design1 from "../assets/images/design-2.png";
import design2 from "../assets/images/design-1.png";
import technicalFoundation from "../assets/images/technical-foundation.png";
import bot from "../assets/images/bot-teacher.gif";
import spons from "../assets/images/sponsore.png";
import banner from "../assets/images/banner.png";

export default function Home() {
  const [lang, setLang] = useState("ja");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ---- Language toggle (default: Japanese) ----
  const T = {
    ja: {
      nav: { home: "ホーム", about: "弊社について", results: "ライブ結果", projects: "プロジェクト", contact: "お問い合わせ" },
      getStarted: "ログイン",
      toggle: "日本語 ⇄ English",

      heroLine1: "自動トレードの",
      heroLine2: "未来",
      heroLine3: "IBL.Co.JP",
      heroDesc:
        "IBL.Co.JPでは、週末を除く24時間365日、トレーダーが中断なく市場に参加できる高度な自動売買システムを開発しております。",

      stat1: "ソフトの世界ランキング",
      stat2: "開発済みのソフト",
      stat3: "経験年数",

      aboutTitle: "弊社について",
      aboutBody:
        "IBL株式会社のオフィシャルウェブサイトへようこそ。当社は2008年に日本で設立されたテクノロジー企業です。創業当初は取引の簡易化を目指し、AIのエッセンスを取り入れたマニュアル取引の研究からスタートいたしました。その後、200回におよぶ厳格なバックテストと最適化を経て、2016年に初の全自動AI取引システム「Type-A」の開発に成功。この技術的ブレイクスルーは、当社のファイナンス市場への理解を飛躍的に深める革命的な契機となりました。現在、当社の基幹AIアルゴリズムである「Blue Samurai」および「Hybrid Samurai」は、世界的なフィンテック・ソリューションとして進化を続けており、現在30種類の通貨ペアにおいて堅牢な運用・テストを行っています。",
      aboutBlocks: [
        {
          title: "進行中のコア・プロジェクト",
          body:
            "革新的なAI技術とポートフォリオ・リスク・エンジン（Portfolio Risk Engine）を通じて、私たちはより洗練されたインテリジェントな取引ソリューションを提供しています。現在、以下の6つのプロジェクトがグローバル市場で稼働・進行中です。\n\n・Blue Samurai：Type A / Type B / Type C\n・Hybrid Samurai：Type A / Type B / Type C\n\n私たちが主戦場とする世界の金融市場は、株式、外国為替、先物、そして暗号資産を合わせ、1日あたりの取引高が1,380兆円に達する世界最大のマーケットです。",
        },
        {
          title: "学術的信頼性と技術的基盤",
          body:
            "当社は、単なるシステム開発会社にとどまりません。ソフトウェア開発エンジニアの約80％が博士号（Ph.D.）相当の高度な専門知識を有しており、高度な数学的アプローチを用いています。現在、テクノロジーの責任ある利用、社会的公正（ソーシャル・ジャスティス）、および「ベーシックインカム」のエコシステム構築に向け、国内外の有力大学・教授陣と共同研究および技術検証を進めています。",
        },
        {
          title: "社会的責任とコンプライアンス",
          body:
            "金融×AI×社会貢献の融合により、私たちはより良い未来を創造します。IBL社が開発する自動取引ソフトウェアは、社会や環境にポジティブな影響を与える「ESG投資」および「インパクト投資」の領域における活用実績が公式に認められています。当社は日本の法規制を遵守し、透明性の高い情報開示を行っています。\n\n法人番号（Japan Corporate ID）：6180301011937\n国税庁法人番号公表サイト：https://ttzk.graffer.jp/corporations/6180301011937\n\n【※投資に関する重要なお知らせ】\n当社は技術開発およびソフトウェア提供企業であり、以下の行為は一切行いません。\n\n投資勧誘・資金の直接的な募集の禁止（No Solicitation）\n将来の利益保証の排除（No Guaranteed Returns）\n金融アドバイス・投資助言行為の排除（No Financial Advice）\n不透明な免責事項による事実の隠蔽の排除",
          linkLabel: "法人番号公表サイトを見る",
        },
      ],
      blueSamuraiLabel: "Blue Samurai:",
      standardTradingLabel: "通常取引:",
      
      projects: {
        typeA: {
  title: "Blue Samurai (タイプA)",
  description:
    "10種類（株・為替・先物・暗号資産）｜Group A（全10ペア）",
  pairs: "EURUSD・GBPUSD・EURGBP・CHFJPY・EURNZD・BTCUSD・US30・HK50・AUDJPY・ETHUSD",
  costPerPair: "1ペアあたりのコスト：約1000NZD",
  capital: "元金：2万1千NZD",
  riskPerPair: "1ペアあたりのリスク(DD)：約25%",
  monthlyProfit: "毎月の利益：8%〜35%",
  normalCost: "通常の取引1ペアあたりのコスト：1万NZD",
  normalCapital: "元金：10万NZD",
  normalRisk: "リスク：約10.96%",
  normalRiskPerPair: "1ペアあたりのリスク(DD)：約10.96%",
  normalProfit: "毎月の利益：約0.448%〜3.14%",
},

typeB: {
  title: "Blue Samurai (タイプB)",
  description:
    "10種類（株・為替・先物・暗号資産）｜Group B（全10ペア）",
  pairs: "USDJPY・EURJPY・NZDJPY・CADJPY・GBPAUD・GBPCHF・BTCXAU・JP225・AUS200・XAUUSD",
  costPerPair: "1ペアあたりのコスト：約1000NZD",
  capital: "元金：2万1千NZD",
  riskPerPair: "1ペアあたりのリスク(DD)：約25%",
  monthlyProfit: "毎月の利益：8%〜35%",
  normalCost: "通常の取引1ペアあたりのコスト：1万NZD",
  normalCapital: "元金：10万NZD",
  normalRisk: "リスク：約10.96%",
  normalRiskPerPair: "1ペアあたりのリスク(DD)：約10.96%",
  normalProfit: "毎月の利益：約0.448%〜3.14%",
},

typeC: {
  title: "Blue Samurai (タイプC)",
  description:
    "10種類（株・為替・先物・暗号資産）｜Group C（全10ペア）",
  pairs: "AUDUSD・GBPCAD・GBPNZD・EURAUD・XAUUSD・UK100・USTEC・US500・DE30・FR40",
  costPerPair: "1ペアあたりのコスト：約1000NZD",
  capital: "元金：2万1千NZD",
  riskPerPair: "1ペアあたりのリスク(DD)：約25%",
  monthlyProfit: "毎月の利益：8%〜35%",
  normalCost: "通常の取引1ペアあたりのコスト：1万NZD",
  normalCapital: "元金：10万NZD",
  normalRisk: "リスク：約10.96%",
  normalRiskPerPair: "1ペアあたりのリスク(DD)：約10.96%",
  normalProfit: "毎月の利益：約0.448%〜3.14%",
},
        // ---- Added (Hybrid Samurai) JP ----
        hybridA: {
          title: "Hybrid Samurai (タイプA)",
          description:
            "Group A｜10銘柄構成",
          pairs: "EURUSD・CHFJPY・BTCUSD・US30・HK50・AUDJPY・EURGBP・GBPCAD・JP225・DE30",
          features: [
            "為替・暗号資産・主要株価指数をバランスよく組み合わせ、特定市場への偏りを抑えた分散型グループ",
            "FX、暗号資産、米国株価指数、香港株価指数、日本株価指数、ドイツ株価指数を組み合わせています。",
            "米国・欧州・アジアの主要株価指数を組み合わせ、地域ごとの市場リスクを分散します。",
            "BTCUSDをType Aに配置し、ETHUSDやXAUUSDとは別グループに分けることで、暗号資産と商品のリスクを分散します。",
            "EURUSDに加え、CHFJPY、AUDJPY、EURGBP、GBPCADなどのクロス通貨を組み合わせ、ドル依存を抑制します。",
            "複数の資産・地域・通貨を組み合わせることで、特定市場への偏りを抑えながら複数市場で収益機会を狙います。",
          ],
          costPerPair: "1ペアあたりのコスト：約1000NZD",
          capital: "元金1セット10ペア：1万5千NZD\n元金6セット60ペア：6万NZD",
          riskPerPair: "1ペアあたりのリスク(DD)：およそ25%",
          monthlyProfit: "毎月の利益：8%〜35%",
          normalCost: "通常の取引1ペアあたりのコスト：1万NZD",
          normalCapital: "元金：10万NZD",
          normalRisk: "リスク：およそ10.96%",
          normalRiskPerPair: "1ペアあたりのリスク(DD)：およそ10.96%",
          normalProfit: "毎月の利益：最低約0.448%から最大約3.14%",
        },
        hybridB: {
          title: "Hybrid Samurai (タイプB)",
          description:
            "Group B｜10銘柄構成",
          pairs: "GBPUSD・USDJPY・EURJPY・CADJPY・ETHUSD・AUS200・NZDJPY・CADCHF・NZDUSD・UK100",
          features: [
            "JPY関連通貨・暗号資産・欧州およびオセアニアの株価指数を組み合わせた分散型グループ",
            "FX、暗号資産、オーストラリア株価指数、英国株価指数を組み合わせています。",
            "USDJPY、EURJPY、CADJPY、NZDJPYなどの円関連ペアを中心に構成し、日本円の動きが大きい相場環境で収益機会を狙います。",
            "ETHUSDをType Bに配置し、BTCUSDやXAUUSDとは別グループに分けることで、暗号資産・商品・為替のリスクを分散します。",
            "AUS200とUK100を組み合わせることで、アジア・オセアニア市場と欧州市場の値動きを活用します。",
            "複数の通貨・暗号資産・地域別株価指数を組み合わせることで、特定市場への偏りを抑えながら複数市場で収益機会を狙います。",
          ],
          costPerPair: "1ペアあたりのコスト：約1000NZD",
          capital: "元金1セット10ペア：1万5千NZD\n元金6セット60ペア：6万NZD",
          riskPerPair: "1ペアあたりのリスク(DD)：およそ25%",
          monthlyProfit: "毎月の利益：6%〜35%",
          normalCost: "通常の取引1ペアあたりのコスト：1万ドル",
          normalCapital: "元金1セット10ペア：15万NZD\n元金6セット60ペア：60万NZD",
          normalRisk: "リスク：およそ10.96%",
          normalRiskPerPair: "1ペアあたりのリスク(DD)：およそ10.96%",
          normalProfit: "毎月の利益：最低約0.448%から最大約3.14%",
        },
        hybridC: {
          title: "Hybrid Samurai (タイプC)",
          description:
            "Group C｜10銘柄構成",
          pairs: "AUDUSD・GBPAUD・USDCHF・EURAUD・XAUUSD・USTEC・US500・FR40・EURNZD・GBPNZD",
          features: [
            "為替・商品・米国および欧州の株価指数をバランスよく組み合わせた分散型グループ",
            "FX、商品・ゴールド、米国テクノロジー株価指数、米国株価指数、フランス株価指数を組み合わせています。",
            "AUDUSD、GBPAUD、USDCHF、EURAUD、EURNZD、GBPNZDを採用し、米ドル・豪ドル・ユーロ・ポンド・NZドル・スイスフランなど複数通貨に分散します。",
            "XAUUSD（ゴールド）をType Cに配置し、為替市場とは異なる商品市場の値動きを活用します。",
            "USTEC、US500、FR40を組み合わせることで、米国テクノロジー市場・米国株式市場・欧州株式市場の値動きを活用します。",
            "複数の通貨・商品・地域別株価指数を組み合わせることで、特定市場への偏りを抑えながら複数市場で収益機会を狙います。",
          ],
          costPerPair: "1ペアあたりのコスト：約1000NZD",
          capital: "元金1セット10ペア：1万5千NZD\n元金6セット60ペア：6万NZD",
          riskPerPair: "1ペアあたりのリスク(DD)：およそ25%",
          monthlyProfit: "毎月の利益：6%〜35%",
          normalCost: "通常の取引1ペアあたりのコスト：1万ドル",
          normalCapital: "元金1セット10ペア：15万NZD\n元金6セット60ペア：60万NZD",
          normalRisk: "リスク：およそ10.96%",
          normalRiskPerPair: "1ペアあたりのリスク(DD)：およそ10.96%",
          normalProfit: "毎月の利益：最低約0.448%から最大約3.14%",
        },
      },

      resultsTitle: "ライブ結果",
      resultsDesc:
        "テストアカウントの成績は、第三者企業によってリアルタイムに公開されます。データはPCやモバイルで可能です。",
      accNo: "アカウント番号",
      client: "金、仮想通貨、株式、FX",
      dep: "頭金",
      start: "開始日",
      seeBook: "MyFxBook",

      aiTitle: "AI Angelプロジェクト",
      aiP1:
        "私たちの使命は明確です。「社会をより良くするために人工知能（AI）を活用していく」ことです。現代の進化する世界では、多くの企業がAIを導入し、これまで人間が担ってきた業務を自動化しています。一方、私たちはこの開発に伴う懸念やコミュニティへの顕在的な悪影響にも理解を深めています。AIが運転を制御するようになれば、勤勉なトラックやタクシーの運転手が生計を立てるのが難しくなるかもしれません。さらに、AIが商品を瞬時に認識できる機能を備えれば、コンビニやスーパーのレジ係が不要になり、多くの人々が失業や経済的困難に直面する可能性があります。",
      aiP2:
        "しかし、私たちのAIソフトウェア開発の焦点は、社会から雇用の機会を奪うのではなく、より公平な未来を創造するという目標をもっています。社会的格差を解消し、弱い立場の人々を支援するために、特に外国為替市場と仮想通貨における自動取引に焦点を当てています。この巨大規模ビジネスの1日の取引額は50兆円に達しており、現在自動為替取引は約23兆円を占めています。このプロジェクトを普遍的な基盤として、社会に安定と包摂性をもたらす可能性を模索しています。\n\n現在、弊社のAIソフトウェアは、運用費用を除いて無料でレンタル可能です。この先駆的な技術は、弊社の日本企業が独自に開発し、豊富な運用経験を持っています。興味のある方は、弊社のホームページで、約20から100以上のアカウントの毎日のライブパフォーマンスデータをご覧いただけます。ぜひ、私たちのプロジェクトをもっと詳しくご覧ください。",

      learnMore: "詳しく見る",
      youtubeTitle: "YouTube：山手システム ライブ取引実績ダッシュボード",
      youtubeSub:
        "山手システムのライブ取引実績をYouTubeでご覧いただけます。最新の配信ページへ移動します。",
      youtubeLive: "LIVE",
      youtubeButton: "ライブを見る",

      riskTitle: "リスクと資金余力について",
      r1:
        "外国為替・先物・オプション取引には高いリスクが伴い、投資資金の一部または全部を失う可能性があります。特に、レバレッジを利用した取引では、大きな利益が期待できる一方で、損失も大きくなる可能性があります。",
      r2:
        "取引を行う際は、これらのリスクを十分に理解したうえで、ご自身の資金状況やリスク許容度を考慮し、生活や資産の維持に必要な資金に影響を与えない範囲で運用してください。",
      r3:
        "過去の運用実績は、将来の成果や利益を保証するものではありません。また、IBLは、本製品の使用または取引判断に起因する直接的・間接的な損失や損害について、一切の責任を負いません。",
      fundsRiskTitle: "Hybrid Samurai V7の資金とリスク",
      fundsRiskBody:
        "Hybrid Samurai V7では、同じシステムを使用する場合でも、投入する運用資金によってリスクに対する資金余力が異なります。\n\n・運用資金が少ない場合\n利益率は相対的に高くなる一方、相場が大きく変動した際の資金余力が小さくなり、Equity（有効証拠金）の変動による影響を受けやすくなります。\n\n・運用資金が多い場合\n利益率は相対的に低くなる一方、Equityの変動に対する資金余力が大きくなり、リスクを抑えた安定性重視の運用が可能になります。\n\nそのため、資金量・リスク許容度・運用目的に応じて、Group 1〜Group 8の中から適したプランを選択できます。",
      importantTitle: "重要事項",
      importantBody:
        "各プランに記載されている利益率やリスクの数値は、将来の運用成果を保証するものではありません。実際の運用結果は、市場環境、価格変動、スプレッド、レバレッジなどの条件によって異なる場合があります。",
      r4: (
  <>
    当社は日本の法規制を遵守し、透明性の高い情報開示を行っています。<br /><br />
    法人番号（Japan Corporate ID）：6180301011937<br /><br />
    国税庁法人番号公表サイト：https://ttzk.graffer.jp/corporations/6180301011937<br /><br />
    <strong>【※投資に関する重要なお知らせ】</strong><br /><br />
    当社は技術開発およびソフトウェア提供企業であり、以下の行為は一切行いません。<br /><br />
    ❌ 投資勧誘・資金の直接的な募集の禁止（No Solicitation）<br /><br />
    ❌ 将来の利益保証の排除（No Guaranteed Returns）<br /><br />
    ❌ 金融アドバイス・投資助言行為の排除（No Financial Advice）<br /><br />
    ❌ 不透明な免責事項による事実の隠蔽
  </>
),
      contactTitle: "お問い合わせ",
      contactSub:
        "ご質問やご意見などがございましたら、以下のフォームにご記入ください。弊社担当者が折り返し返信いたします。",
      form: { name: "First Name", lastName: "Last Name", email: "Email", number: "Your Number", subject: "Subject", msg: "Message", send: "送信" },

      zoomTitle: "オンライン相談",
      zoomBody:
        "ご興味のある方にはオンラインでのミーティングが可能です。お時間がありましたら、弊社代表とオンラインで一度お打ち合わせをさせていただきたく存じます。以下のスケジュール調整ツールから、ご都合の良いお時間をお選びいただければ幸いです。",
      zoomBtn: "Zoom Meeting",

      footerBrand: "IBLのパートナー企業",
      footerBadge: "IBL リワード",
      footerContact: "お問い合わせ",
      footerEmail: "info@ai-ibl.jp",
      footerAddr: "愛知県豊川市市田町西赤早稲20",
      footerHours: "平日：08:00~17:00",
      copy: "Copyright © 2024 Trading Strategy - IBL Company. All rights reserved.",
    },
    en: {
      nav: { home: "Home", about: "About Us", results: "Live Results", projects: "Projects", contact: "Contact" },
      getStarted: "Login",
      toggle: "English ⇄ 日本語",

      heroLine1: "The Future of",
      heroLine2: "",
      heroLine3: "Automated Trading",
      heroDesc:
        "IBL.Co.JP develops advanced automated trading systems that allow traders to participate in the market 24/7 without interruption, excluding weekends.",

      stat1: "World Software Ranking",
      stat2: "Developed Software",
      stat3: "Years of Experience",

      aboutTitle: "About Us",
      aboutBody:
        'Welcome to the official website of IBL Co., Ltd. We are a technology company established in Japan in 2008. In our early years, we began by researching manual trading enhanced with the essence of AI, with the goal of simplifying transactions. After 200 rigorous backtests and optimization cycles, we successfully developed our first fully automated AI trading system, "Type-A," in 2016. This technical breakthrough became a revolutionary turning point that dramatically deepened our understanding of financial markets. Today, our core AI algorithms, "Blue Samurai" and "Hybrid Samurai," continue to evolve as global fintech solutions, with robust operation and testing currently underway across 30 currency pairs.',
      aboutBlocks: [
        {
          title: "Core Projects in Progress",
          body:
            "Through innovative AI technology and a Portfolio Risk Engine, we provide more refined and intelligent trading solutions. The following six projects are currently operating or progressing in global markets.\n\nBlue Samurai: Type A / Type B / Type C\nHybrid Samurai: Type A / Type B / Type C\n\nThe global financial markets where we operate, combining stocks, foreign exchange, futures, and crypto assets, form the world's largest market, with daily trading volume reaching 1,380 trillion yen.",
        },
        {
          title: "Academic Reliability and Technical Foundation",
          body:
            "We are more than a system development company. Approximately 80% of our software development engineers have advanced expertise equivalent to a Ph.D., and our work uses advanced mathematical approaches. We are currently conducting joint research and technical verification with leading universities and professors in Japan and abroad to support responsible technology use, social justice, and the creation of a basic income ecosystem.",
        },
        {
          title: "Social Responsibility and Compliance",
          body:
            "By combining finance, AI, and social contribution, we aim to create a better future. IBL's automated trading software has been officially recognized for use in ESG investment and impact investment fields that create positive social and environmental impact. We comply with Japanese laws and regulations and disclose information transparently.\n\nJapan Corporate ID: 6180301011937\nNational Tax Agency corporate number publication site: https://ttzk.graffer.jp/corporations/6180301011937\n\nImportant Investment Notice\nWe are a technology development and software provider, and we do not engage in the following activities.\n\nNo solicitation or direct fundraising\nNo guaranteed returns\nNo financial advice or investment advisory services\nNo concealment of facts through unclear disclaimers",
          linkLabel: "View Corporate Number Site",
        },
      ],
      blueSamuraiLabel: "Blue Samurai:",
      standardTradingLabel: "Standard Trading:",

      projects: {
        typeA: {
          title: "Blue Samurai (Type A)",
          description:
            "10 types (stocks, forex, futures, cryptocurrencies) | Group A (10 pairs total) ※Using a mix of scalping and swing techniques",
          pairs: "EURUSD・GBPUSD・EURGBP・CHFJPY・EURNZD・BTCUSD・US30・HK50・AUDJPY・ETHUSD",
          costPerPair: "Cost per pair: Approximately $1,000",
          capital: "Capital: NZD $21,000",
          riskPerPair: "Risk per pair (DD): Approximately 25%",
          monthlyProfit: "Monthly profit: 8%~35%",
          normalCost: "Normal trading cost per pair: $10,000",
          normalCapital: "Capital: $100,000",
          normalRisk: "Risk: Approximately 10.96%",
          normalRiskPerPair: "Risk per pair (DD): Approximately 10.96%",
          normalProfit: "Monthly profit: Minimum ~0.448% to maximum ~3.14%",
        },
        typeB: {
          title: "Blue Samurai (Type B)",
          description:
            "10 types (stocks, forex, futures, cryptocurrencies) | Group B (10 pairs total) ※Using mixed strategies combining scalping and swing",
          pairs: "USDJPY・EURJPY・NZDJPY・CADJPY・GBPAUD・GBPCHF・BTCXAU・JP225・AUS200・XAUUSD",
          costPerPair: "Cost per pair: Approximately $1,000",
          capital: "Capital: NZD $21,000",
          riskPerPair: "Risk per pair (DD): Approximately 25%",
          monthlyProfit: "Monthly profit: 8%~35%",
          normalCost: "Normal trading cost per pair: $10,000",
          normalCapital: "Capital: $100,000",
          normalRisk: "Risk: Approximately 10.96%",
          normalRiskPerPair: "Risk per pair (DD): Approximately 10.96%",
          normalProfit: "Monthly profit: Minimum ~0.448% to maximum ~3.14%",
        },
        typeC: {
          title: "Blue Samurai (Type C)",
          description:
            "10 types (stocks, forex, futures, cryptocurrencies) | Group C (10 pairs total) ※Using mixed strategies combining scalping and swing",
          pairs: "AUDUSD・GBPCAD・GBPNZD・EURAUD・XAUUSD・UK100・USTEC・US500・DE30・FR40",
          costPerPair: "Cost per pair: Approximately $1,000",
          capital: "Capital: NZD $21,000",
          riskPerPair: "Risk per pair (DD): Approximately 25%",
          monthlyProfit: "Monthly profit: 8%~35%",
          normalCost: "Normal trading cost per pair: $10,000",
          normalCapital: "Capital: $100,000",
          normalRisk: "Risk: Approximately 10.96%",
          normalRiskPerPair: "Risk per pair (DD): Approximately 10.96%",
          normalProfit: "Monthly profit: Minimum ~0.448% to maximum ~3.14%",
        },

        // ---- Added (Hybrid Samurai) EN ----
        hybridA: {
          title: "Hybrid Samurai (Type A)",
          description:
            "Group A | 10 instruments",
          pairs: "EURUSD・CHFJPY・BTCUSD・US30・HK50・AUDJPY・EURGBP・GBPCAD・JP225・DE30",
          features: [
            "A diversified group that balances forex, crypto assets, and major stock indices while reducing dependence on any single market.",
            "Combines FX, crypto assets, U.S. stock indices, Hong Kong stock indices, Japanese stock indices, and German stock indices.",
            "Uses major U.S., European, and Asian stock indices to diversify regional market risk.",
            "Places BTCUSD in Type A, separate from ETHUSD and XAUUSD, to diversify crypto and commodity risk.",
            "Combines EURUSD with cross-currency pairs such as CHFJPY, AUDJPY, EURGBP, and GBPCAD to reduce U.S. dollar dependency.",
            "Combines multiple assets, regions, and currencies to seek opportunities across markets while reducing concentration risk.",
          ],
          costPerPair: "Cost per pair: ~NZ$1,000",
          capital: "Capital (1 set / 10 pairs): NZ$15,000\nCapital (6 sets / 60 pairs): NZ$60,000",
          riskPerPair: "Risk per pair (DD): ~25%",
          monthlyProfit: "Monthly profit: 8%–35%",
          normalCost: "Normal trading cost per pair: NZ$10,000",
          normalCapital: "Capital: NZ$100,000",
          normalRisk: "Risk: ~10.96%",
          normalRiskPerPair: "Risk per pair (DD): ~10.96%",
          normalProfit: "Monthly profit: ~0.448% (min) to ~3.14% (max)",
        },
        hybridB: {
          title: "Hybrid Samurai (Type B)",
          description:
            "Group B | 10 instruments",
          pairs: "GBPUSD・USDJPY・EURJPY・CADJPY・ETHUSD・AUS200・NZDJPY・CADCHF・NZDUSD・UK100",
          features: [
            "A diversified group combining JPY-related currencies, crypto assets, and European and Oceanian stock indices.",
            "Combines FX, crypto assets, the Australian stock index, and the U.K. stock index.",
            "Centers on JPY-related pairs such as USDJPY, EURJPY, CADJPY, and NZDJPY to seek opportunities when Japanese yen movement is significant.",
            "Places ETHUSD in Type B, separate from BTCUSD and XAUUSD, to diversify crypto, commodity, and forex risk.",
            "Combines AUS200 and UK100 to use price movement across Asian, Oceanian, and European markets.",
            "Combines multiple currencies, crypto assets, and regional stock indices to seek opportunities across markets while reducing concentration risk.",
          ],
          costPerPair: "Cost per pair: ~NZ$1,000",
          capital: "Capital (1 set / 10 pairs): NZ$15,000\nCapital (6 sets / 60 pairs): NZ$60,000",
          riskPerPair: "Risk per pair (DD): ~25%",
          monthlyProfit: "Monthly profit: 6%–35%",
          normalCost: "Normal trading cost per pair: $10,000",
          normalCapital: "Capital (1 set / 10 pairs): NZ$150,000\nCapital (6 sets / 60 pairs): NZ$600,000",
          normalRisk: "Risk: ~10.96%",
          normalRiskPerPair: "Risk per pair (DD): ~10.96%",
          normalProfit: "Monthly profit: ~0.448% (min) to ~3.14% (max)",
        },
        hybridC: {
          title: "Hybrid Samurai (Type C)",
          description:
            "Group C | 10 instruments",
          pairs: "AUDUSD・GBPAUD・USDCHF・EURAUD・XAUUSD・USTEC・US500・FR40・EURNZD・GBPNZD",
          features: [
            "A diversified group that balances forex, commodities, and U.S. and European stock indices.",
            "Combines FX, gold as a commodity, the U.S. technology stock index, the U.S. stock index, and the French stock index.",
            "Uses AUDUSD, GBPAUD, USDCHF, EURAUD, EURNZD, and GBPNZD to diversify across USD, AUD, EUR, GBP, NZD, and CHF exposure.",
            "Places XAUUSD (gold) in Type C to use commodity market movement that differs from the forex market.",
            "Combines USTEC, US500, and FR40 to use price movement across U.S. technology, U.S. equity, and European equity markets.",
            "Combines multiple currencies, commodities, and regional stock indices to seek opportunities across markets while reducing concentration risk.",
          ],
          costPerPair: "Cost per pair: ~NZ$1,000",
          capital: "Capital (1 set / 10 pairs): NZ$15,000\nCapital (6 sets / 60 pairs): NZ$60,000",
          riskPerPair: "Risk per pair (DD): ~25%",
          monthlyProfit: "Monthly profit: 6%–35%",
          normalCost: "Normal trading cost per pair: $10,000",
          normalCapital: "Capital (1 set / 10 pairs): NZ$150,000\nCapital (6 sets / 60 pairs): NZ$600,000",
          normalRisk: "Risk: ~10.96%",
          normalRiskPerPair: "Risk per pair (DD): ~10.96%",
          normalProfit: "Monthly profit: ~0.448% (min) to ~3.14% (max)",
        },
      },

      resultsTitle: "Live Results",
      resultsDesc:
        "Test account results are published in real time by a third-party company. Data can be accessed via PC or mobile.",
      accNo: "Account Number",
      client: "Gold, Cryptocurrencies, Stocks, FX",
      dep: "Initial Deposit",
      start: "Start Date",
      seeBook: "MyFxBook",

      aiTitle: "AI Angel Project",
      aiP1:
        'Our mission is clear: "To utilize artificial intelligence (AI) to make society better." In today\'s evolving world, many companies are implementing AI and automating tasks previously performed by humans. At the same time, we deeply understand the concerns and potential negative impacts this development may have on communities. If AI takes over driving controls, diligent truck and taxi drivers may find it difficult to make a living. Furthermore, if AI gains the ability to instantly recognize products, convenience store and supermarket cashiers may become unnecessary, potentially leaving many people unemployed and facing economic hardship.',
      aiP2:
        "However, our focus in AI software development is not to take away employment opportunities from society but to create a more equitable future. We particularly focus on automated trading in the foreign exchange and cryptocurrency markets to reduce social disparities and support vulnerable people. This massive-scale business reaches daily trading volumes of 50 trillion yen, with automated forex trading currently accounting for about 23 trillion yen. We are exploring the potential of this project as a universal foundation to bring stability and inclusivity to society.\n\nCurrently, our AI software is available for rent free of charge (excluding operational costs). This pioneering technology was independently developed by our Japanese company and has extensive operational experience. Interested parties can view daily live performance data for approximately 20 to 100+ accounts on our website. Please take a closer look at our projects.",

      learnMore: "WebSite",
      youtubeTitle: "YouTube: Yamate System Live Trading Performance Dashboard",
      youtubeSub:
        "Watch the Yamate System live trading performance dashboard on YouTube. This opens the latest live page.",
      youtubeLive: "LIVE",
      youtubeButton: "Watch Live",

      riskTitle: "Risk and Capital Buffer",
      r1:
        "Foreign exchange, futures, and options trading involve significant risk, and you may lose part or all of your investment capital. In particular, leveraged trading can create the potential for large gains, but it can also increase losses.",
      r2:
        "Before trading, please fully understand these risks and operate only within a range that does not affect funds required for your living expenses or asset maintenance, taking your financial condition and risk tolerance into account.",
      r3:
        "Past operating performance does not guarantee future results or profits. IBL assumes no responsibility for any direct or indirect losses or damages arising from the use of this product or from trading decisions.",
      fundsRiskTitle: "Hybrid Samurai V7 Capital and Risk",
      fundsRiskBody:
        "With Hybrid Samurai V7, even when using the same system, the capital buffer against risk differs depending on the amount of operating funds allocated.\n\nWhen operating funds are smaller\nThe profit rate may be relatively higher, but the capital buffer becomes smaller when markets move significantly, making the account more sensitive to changes in Equity.\n\nWhen operating funds are larger\nThe profit rate may be relatively lower, but the capital buffer against Equity movement becomes larger, making it possible to prioritize stability and reduce risk.\n\nFor this reason, an appropriate plan can be selected from Group 1 to Group 8 according to capital amount, risk tolerance, and operating purpose.",
      importantTitle: "Important Notice",
      importantBody:
        "The profit-rate and risk figures shown for each plan do not guarantee future operating results. Actual results may differ depending on market conditions, price fluctuations, spreads, leverage, and other factors.",

      contactTitle: "Contact Us",
      contactSub:
        "If you have any questions or comments, please fill out the form below. Our representative will reply to you shortly.",
      form: { name: "First Name", lastName: "Last Name", email: "Email", number: "Your Number", subject: "Subject", msg: "Message", send: "Send" },

      zoomTitle: "Online Consultation",
      zoomBody:
        "Online meetings are available for interested parties. If you have time, we would like to schedule an online meeting with our representative. Please select a convenient time from the schedule adjustment tool below.",
      zoomBtn: "Zoom Meeting",

      footerBrand: "IBL Partner Companies",
      footerBadge: "IBL Reward",
      footerContact: "Contact Us",
      footerEmail: "info@ai-ibl.jp",
      footerAddr: "20 Nishiachiwase, Ichidacho, Toyokawa City, Aichi Prefecture",
      footerHours: "Weekdays: 08:00~17:00",
      copy: "Copyright © 2024 Trading Strategy - IBL Company. All rights reserved.",
    },
  };
  const L = T[lang];
  const sectionTitle = `${isMobile ? "text-2xl" : "text-3xl md:text-4xl"} font-bold leading-tight`;
  const subSectionTitle = `${isMobile ? "text-xl" : "text-2xl"} font-bold leading-snug`;
  const bodyText = "text-base md:text-lg text-gray-300 leading-8 whitespace-pre-line";
  const riskText = "text-sm md:text-base text-gray-300 leading-7 whitespace-pre-line";
  const corporateRegistryUrl = "https://ttzk.graffer.jp/corporations/6180301011937";
  const complianceBodyParts = L.aboutBlocks[2].body.split(corporateRegistryUrl);
  const youtubeLiveUrl = "https://www.youtube.com/@IBL_Samurai/live";
  const youtubePreviewImageUrl = "https://i.ytimg.com/vi/EYTK-ioz8Lc/maxresdefault.jpg";

  const [countValues, setCountValues] = useState({
    stat1: 0,
    stat2: 0,
    stat3: 0,
  });
  useEffect(() => {
    const duration = 2000; // Animation duration in ms
    const startTime = Date.now();

    const animate = () => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / duration, 1);

      setCountValues({
        stat1: Math.floor(progress * 10),
        stat2: Math.floor(progress * 120),
        stat3: Math.floor(progress * 3),
      });
      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    animate();
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    lastName: "",
    email: "",
    number: "",
    subject: "",
    msg: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await fetch("https://formsubmit.co/ajax/info@ai-ibl.jp", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          name: formData.name,
          lastName: formData.lastName,
          email: formData.email,
          number: formData.number,
          subject: formData.subject,
          message: formData.msg,
          _subject: `New Contact Form Submission: ${formData.subject}`,
          _template: "box",
        }),
      });

      const data = await response.json();
      if (data.success) {
        setSubmitMessage("Message sent successfully!");
        setFormData({
          name: "",
          lastName: "",
          email: "",
          number: "",
          subject: "",
          msg: "",
        });
      } else {
        setSubmitMessage("Failed to send message. Please try again.");
      }
    } catch (error) {
      setSubmitMessage("An error occurred. Please try again later.");
    } finally {
      setIsSubmitting(false);
      setTimeout(() => setSubmitMessage(""), 5000);
    }
  };
  return (
    <div className="bg-black text-white font-sans">
      {/* Mobile Navbar */}
      {isMobile && (
        <div className="fixed top-0 left-0 w-full bg-black z-50 px-4 py-3 flex justify-between items-center border-b border-gray-800">
          <div className="flex items-center gap-2">
            <img src={logo} alt="IBL Logo" className="h-12" />
          </div>

          <div className="flex items-center gap-2">
            <button onClick={() => setMenuOpen(!menuOpen)} className="text-white focus:outline-none">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {menuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>
      )}

      {/* Mobile Menu */}
      {isMobile && menuOpen && (
        <div className="fixed top-16 left-0 w-full bg-black z-50 px-4 py-3 border-b border-gray-800">
          <ul className="space-y-4">
            <li>
              <a href="#home" className="block hover:text-cyan-400" onClick={() => setMenuOpen(false)}>
                {L.nav.home}
              </a>
            </li>
            <li>
              <a href="#about" className="block hover:text-cyan-400" onClick={() => setMenuOpen(false)}>
                {L.nav.about}
              </a>
            </li>
            <li>
              <a href="#results" className="block hover:text-cyan-400" onClick={() => setMenuOpen(false)}>
                {L.nav.results}
              </a>
            </li>
            <li>
              <a href="#projects" className="block hover:text-cyan-400" onClick={() => setMenuOpen(false)}>
                {L.nav.projects}
              </a>
            </li>
            <li>
              <a href="#contact" className="block hover:text-cyan-400" onClick={() => setMenuOpen(false)}>
                {L.nav.contact}
              </a>
            </li>
          </ul>
          <div className="mt-4 flex gap-2">
            <Link to="/login" className="bg-cyan-500 hover:bg-cyan-600 text-white px-3 py-1 rounded text-sm">
              {L.getStarted}
            </Link>
            <button
              onClick={() => setLang((p) => (p === "ja" ? "en" : "ja"))}
              className="bg-cyan-500 hover:bg-cyan-600 text-white px-3 py-1 rounded text-sm"
            >
              {L.toggle}
            </button>
          </div>
        </div>
      )}

      {/* Desktop Navbar */}
      {!isMobile && (
        <nav className="absolute top-0 left-0 w-full flex items-center justify-between px-8 py-4 z-50">
          <div className="flex items-center gap-2">
            <img src={logo} alt="IBL Logo" className="h-20" />
          </div>

          <ul className="flex space-x-6 text-sm justify-center flex-1">
            <li>
              <a href="#home" className="hover:text-cyan-400">
                {L.nav.home}
              </a>
            </li>
            <li>
              <a href="#about" className="hover:text-cyan-400">
                {L.nav.about}
              </a>
            </li>
            <li>
              <a href="#results" className="hover:text-cyan-400">
                {L.nav.results}
              </a>
            </li>
            <li>
              <a href="#projects" className="hover:text-cyan-400">
                {L.nav.projects}
              </a>
            </li>
            <li>
              <a href="#contact" className="hover:text-cyan-400">
                {L.nav.contact}
              </a>
            </li>
          </ul>

          <div className="flex gap-4 items-center">
            <Link to="/login">
              <button className="bg-cyan-500 hover:bg-cyan-600 text-white px-3 py-1 rounded text-sm">
                {L.getStarted}
              </button>
            </Link>
            <button
              onClick={() => setLang((p) => (p === "ja" ? "en" : "ja"))}
              className="bg-cyan-500 hover:bg-cyan-600 text-white px-3 py-1 rounded text-sm"
            >
              {L.toggle}
            </button>
          </div>
        </nav>
      )}

      {/* HERO */}
      <section
        id="home"
        className={`flex ${
          isMobile ? "flex-col pt-32 pb-16 px-6" : "flex-row items-center justify-between px-16 py-32"
        } bg-gradient-to-tr from-black to-[#111] min-h-screen`}
      >
        <div className={`${isMobile ? "w-full mb-10" : "w-1/2 pr-10"}`}>
          <h1 className={`${isMobile ? "text-4xl" : "text-6xl"} font-extrabold leading-tight mb-6`}>
            {lang === "ja" ? (
              <>
                {L.heroLine1} <br />
                {L.heroLine2} <br />
                <span className="text-cyan-400">{L.heroLine3}</span>
              </>
            ) : (
              <>
                {L.heroLine1} <br />
                <span className="text-cyan-400">{L.heroLine3}</span>
              </>
            )}
          </h1>
          <p className="text-gray-400 text-lg">{L.heroDesc}</p>
        </div>

        <div className={`${isMobile ? "w-full" : "w-1/2"} relative flex justify-center`}>
          <div className="rounded-full bg-[#111] p-4 relative">
            <img src={hero} alt="Hero Graphic" className={`${isMobile ? "w-full" : "w-[500px]"} max-w-full`} />
          </div>
        </div>
      </section>

      {/* STATS SECTION */}
      <section className="bg-black py-16 px-6 text-center">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
          {[1, 2, 3].map((stat, index) => (
            <div key={index} className="border border-white rounded-lg py-10 px-4">
              <h2 className="text-5xl font-bold text-white mb-2 font-sans">
                {index === 0 ? `# ${countValues.stat1}` : index === 1 ? `${countValues.stat2} +` : `${countValues.stat3} +`}
              </h2>
              <p className="text-white text-lg font-light">
                {index === 0 ? L.stat1 : index === 1 ? L.stat2 : L.stat3}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* COMPANY INFO SECTION */}
      <section id="about" className="bg-black text-white py-20 px-6 md:px-20">
        <div className={`max-w-7xl mx-auto grid ${isMobile ? "grid-cols-1" : "md:grid-cols-2"} items-center gap-12 md:gap-16`}>
          <div className="flex justify-center order-2 md:order-1">
            <img src={design1} alt="Company Graphic" className={`${isMobile ? "w-full" : "w-[88%]"} max-w-lg max-w-full`} />
          </div>
          <div className="order-1 md:order-2 max-w-2xl space-y-10">
            <div>
              <h2 className={`${sectionTitle} mb-6`}>{L.aboutTitle}</h2>
              <p className={bodyText}>{L.aboutBody}</p>
            </div>
            <div className="pt-2">
              <h3 className={`${subSectionTitle} mb-4`}>{L.aboutBlocks[0].title}</h3>
              <p className={bodyText}>{L.aboutBlocks[0].body}</p>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto mt-24">
          <div className={`grid ${isMobile ? "grid-cols-1" : "md:grid-cols-2"} items-start gap-12 md:gap-16`}>
            <div className="max-w-2xl space-y-12 bg-transparent border-0 shadow-none p-0">
              <div>
                <h3 className={`${subSectionTitle} mb-5`}>{L.aboutBlocks[1].title}</h3>
                <p className={bodyText}>{L.aboutBlocks[1].body}</p>
              </div>
              <div>
                <h3 className={`${subSectionTitle} mb-5`}>{L.aboutBlocks[2].title}</h3>
                <p className={bodyText}>{complianceBodyParts[0].trimEnd()}</p>
                <a
                  href={corporateRegistryUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="mt-4 inline-flex items-center rounded-md bg-cyan-500 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-cyan-600"
                >
                  {L.aboutBlocks[2].linkLabel}
                </a>
                <p className={`${bodyText} mt-6`}>{complianceBodyParts[1].trimStart()}</p>
              </div>
            </div>
            <div className="flex justify-center md:pt-8">
              <img
                src={technicalFoundation}
                alt="Technical Foundation"
                className={`${isMobile ? "w-full" : "w-[88%]"} max-w-lg rounded-xl max-w-full`}
              />
            </div>
          </div>

        </div>
      </section>

      {/* PROJECTS SECTION */}
      <section id="projects" className="bg-black text-white pt-20 pb-28 px-4">
        <div className="w-full mb-16">
          <img
            src={banner}
            alt="Projects Banner"
            className="w-full h-[280px] object-cover rounded-none shadow-none max-w-full"
          />
        </div>

        <div className="max-w-6xl mx-auto">
          <div className={`grid ${isMobile ? "grid-cols-1 gap-8" : "grid-cols-3 gap-6"}`}>
            {[
              "hybridA",
              "hybridB",
              "hybridC",
            ].map((type, index) => (
              <div key={index} className="bg-black border border-gray-400 rounded-xl shadow-lg overflow-hidden">
                <div className="bg-cyan-900 text-white text-center py-3 px-6 rounded-t-xl">
                  <h3 className="text-lg font-bold tracking-wide">{L.projects[type].title}</h3>
                </div>
                <div className="px-6 py-6 space-y-4 text-sm leading-relaxed">
                  <p className="text-gray-300">{L.projects[type].description}</p>
                  <p className="text-cyan-400 font-medium">{L.projects[type].pairs}</p>

                  {L.projects[type].features ? (
                    <>
                      <div className="border-t border-gray-700" />
                      <ul className="list-disc list-inside space-y-2 text-gray-300">
                        {L.projects[type].features.map((feature, featureIndex) => (
                          <li key={featureIndex}>{feature}</li>
                        ))}
                      </ul>
                    </>
                  ) : (
                    <div className="grid grid-cols-1 gap-3 mt-4">
                      <div>
                        <p className="font-semibold text-gray-200">{L.blueSamuraiLabel}</p>
                        <p>{L.projects[type].costPerPair}</p>
                        <p className="whitespace-pre-line">{L.projects[type].capital}</p>
                        <p>{L.projects[type].riskPerPair}</p>
                        <p>{L.projects[type].monthlyProfit}</p>
                      </div>

                      <div className="pt-3 mt-3 border-t border-gray-700">
                        <p className="font-semibold text-gray-200">{L.standardTradingLabel}</p>
                        <p>{L.projects[type].normalCost}</p>
                        <p className="whitespace-pre-line">{L.projects[type].normalCapital}</p>
                        <p>{L.projects[type].normalRisk}</p>
                        <p>{L.projects[type].normalRiskPerPair}</p>
                        <p>{L.projects[type].normalProfit}</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* LIVE RESULTS SECTION */}
      <section id="results" className="bg-black text-white py-20 px-4 md:px-20">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className={`${isMobile ? "text-2xl" : "text-3xl md:text-4xl"} font-bold mb-2`}>{L.resultsTitle}</h2>
          <p className="text-sm text-gray-300 mb-10">{L.resultsDesc}</p>

          <div className={`grid gap-8 ${isMobile ? "grid-cols-1" : "md:grid-cols-3"}`}>
            {[
              {
                title: "HYBRID SAMURAI TYPE A",
                accNo: "233120766",
                dep: "NZ$10,000.73",
                start: "2026/08/17",
                pageUrl: "https://www.myfxbook.com/members/TestSamurai30Ai/07661-llm-test-n-green/12210125",
                widgetUrl: "https://widget.mfbcdn.net/widget/widget.png?accountOid=12210125&type=6",
              },
              {
                title: "HYBRID SAMURAI TYPE B",
                accNo: "439188459",
                dep: "NZ$10,000.00",
                start: "2026/06/10",
                pageUrl: "https://www.myfxbook.com/members/TestSamurai30Ai/8459hybrid-samurai-agents-forex-t/12218197",
                widgetUrl: "https://widget.mfbcdn.net/widget/widget.png?accountOid=12218197&type=6",
              },
              {
                title: "HYBRID SAMURAI TYPE C",
                accNo: "439178401",
                dep: "AUC20,861.00",
                start: "2026/09/04",
                pageUrl: "https://www.myfxbook.com/members/TestSamurai30Ai/8401hybrid-samurai-hermes-typec-v1/12207958",
                widgetUrl: "https://widget.mfbcdn.net/widget/widget.png?accountOid=12207958&type=6",
              },
            ].map((item, index) => (
              <div key={index} className="bg-zinc-900 rounded-xl shadow-md p-4">
                <h3 className="text-lg font-semibold mb-2">{item.title}</h3>
                <a href={item.pageUrl} target="_blank" rel="noreferrer">
                  <img src={item.widgetUrl} alt={`${item.title} widget`} className="w-full rounded-md mb-4 max-w-full" />
                </a>
                <div className="text-sm text-gray-300 space-y-1 text-left">
                  {item.accNo && (
                    <p>
                      <strong>{L.accNo}:</strong> {item.accNo}
                    </p>
                  )}

                  {/* <-- Here: conditional rendering for client line.
                      For BLUE SAMURAI TYPE A show only the value (no "label: value")
                      Otherwise keep original labeled format. */}
                  {item.title === "BLUE SAMURAI TYPE A" ? (
                    <p>{L.client}</p>
                  ) : (
                    <p>
                      <strong>{L.client}:</strong> {L.client}
                    </p>
                  )}

                  {item.dep && (
                    <p>
                      <strong>{L.dep}:</strong> {item.dep}
                    </p>
                  )}
                  {item.start && (
                    <p>
                      <strong>{L.start}:</strong> {item.start}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-10">
            <a
              href="https://www.myfxbook.com/members/IBLFX"
              target="_blank"
              className="inline-block bg-cyan-500 text-white font-semibold py-2 px-6 rounded-lg hover:bg-cyan-600 transition"
              rel="noreferrer"
            >
              {L.seeBook}
            </a>
          </div>
        </div>
      </section>

      {/* AI ANGEL PROJECT & RISK DISCLOSURE SECTION */}
      <section id="ai-project" className="bg-black text-white px-4 md:px-20 py-20">
        <div className="max-w-7xl mx-auto space-y-24">
          {/* AI Angel Project */}
          <div className={`grid ${isMobile ? "grid-cols-1" : "md:grid-cols-2"} gap-12 items-center`}>
            <div className="flex justify-center order-2 md:order-1">
              <img src={bot} alt="AI Angel" className="max-w-sm md:max-w-md rounded-xl max-w-full" />
            </div>

            <div className="order-1 md:order-2">
              <h2 className={`${isMobile ? "text-xl" : "text-2xl md:text-3xl"} font-bold mb-4`}>{L.aiTitle}</h2>
              <p className="text-sm md:text-base text-gray-300 leading-relaxed mb-6 whitespace-pre-line">{L.aiP1}</p>
              <p className="text-sm md:text-base text-gray-300 leading-relaxed mb-6 whitespace-pre-line">{L.aiP2}</p>
              <a
                href="https://aiangel.org/"
                className="inline-block bg-cyan-500 hover:bg-cyan-600 text-white px-6 py-2 text-sm font-semibold rounded-md transition"
              >
                {L.learnMore}
              </a>
            </div>
          </div>

          {/* Risk Disclosure */}
          <div className={`grid ${isMobile ? "grid-cols-1" : "md:grid-cols-2"} gap-12 md:gap-16 items-start`}>
            <div className="max-w-2xl space-y-10">
              <div>
                <h2 className={`${subSectionTitle} mb-5`}>{L.riskTitle}</h2>
                <p className={riskText}>
                  {L.r1}
                  {"\n\n"}
                  {L.r2}
                  {"\n\n"}
                  {L.r3}
                </p>
              </div>
              <div>
                <h3 className={`${subSectionTitle} mb-5`}>{L.fundsRiskTitle}</h3>
                <p className={riskText}>{L.fundsRiskBody}</p>
                <h4 className="text-base md:text-lg font-semibold mt-8 mb-3">{L.importantTitle}</h4>
                <p className={riskText}>{L.importantBody}</p>
              </div>
            </div>

            <div className="flex justify-center md:pt-2">
              <img src={design2} alt="Risk Disclosure" className={`${isMobile ? "w-full" : "w-[88%]"} max-w-lg rounded-xl max-w-full`} />
            </div>
          </div>
        </div>
      </section>

      {/* YOUTUBE LIVE SECTION */}
      <section className="bg-black text-white px-4 md:px-20 pb-20">
        <div className="max-w-7xl mx-auto">
          <div
            className={`grid ${isMobile ? "grid-cols-1" : "md:grid-cols-[1fr_1.25fr]"} overflow-hidden rounded-xl border border-gray-800 bg-zinc-950/80 shadow-lg`}
          >
            <div className="p-6 md:p-8 flex flex-col justify-center">
              <div className="mb-4 flex items-center gap-3">
                <span className="inline-flex items-center rounded-full bg-red-600 px-3 py-1 text-xs font-bold tracking-wider text-white">
                  {L.youtubeLive}
                </span>
                <span className="h-px flex-1 bg-gray-800" />
              </div>
              <h2 className={`${isMobile ? "text-xl" : "text-2xl md:text-3xl"} font-bold leading-tight`}>
                {L.youtubeTitle}
              </h2>
              <p className="mt-4 text-sm md:text-base leading-7 text-gray-300">{L.youtubeSub}</p>
              <a
                href={youtubeLiveUrl}
                target="_blank"
                rel="noreferrer"
                className="mt-6 inline-flex w-fit items-center rounded-md bg-red-600 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-red-500"
              >
                {L.youtubeButton}
              </a>
            </div>

            <div className="bg-black p-3 md:p-4">
              <a
                href={youtubeLiveUrl}
                target="_blank"
                rel="noreferrer"
                aria-label={L.youtubeTitle}
                className="group/preview relative block aspect-video overflow-hidden rounded-lg bg-black"
              >
                <img
                  src={youtubePreviewImageUrl}
                  alt={L.youtubeTitle}
                  className="h-full w-full object-cover transition duration-300 group-hover/preview:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-black/20" />
                <div className="absolute left-4 top-4 rounded bg-red-600 px-2.5 py-1 text-xs font-bold text-white">
                  {L.youtubeLive}
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="flex h-20 w-20 items-center justify-center rounded-full bg-red-600 text-white shadow-2xl shadow-red-900/50 transition group-hover/preview:scale-110 group-hover/preview:bg-red-500">
                    <svg className="ml-1 h-9 w-9" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                      <path d="M8 5v14l11-7z" />
                    </svg>
                  </div>
                </div>
                <div className="absolute bottom-4 left-4 right-4 text-sm font-semibold text-white">
                  {L.youtubeTitle}
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* CONTACT SECTION */}
      <section id="contact" className="bg-black text-white px-4 md:px-20 py-24">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className={`${isMobile ? "text-2xl" : "text-3xl md:text-4xl"} font-bold mb-2`}>{L.contactTitle}</h2>
            <p className="text-gray-400 text-sm md:text-base">{L.contactSub}</p>
          </div>

          <div className={`grid ${isMobile ? "grid-cols-1" : "md:grid-cols-2"} gap-12 items-start`}>
            <form className="space-y-4" onSubmit={handleSubmit}>
              <div className={`flex ${isMobile ? "flex-col" : "flex-row"} gap-4`}>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder={L.form.name}
                  className="w-full bg-white text-black px-4 py-3 rounded-xl outline-none"
                  required
                />
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  placeholder={L.form.lastName}
                  className="w-full bg-white text-black px-4 py-3 rounded-xl outline-none"
                  required
                />
              </div>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder={L.form.email}
                className="w-full bg-white text-black px-4 py-3 rounded-xl outline-none"
                required
              />
              <input
                type="text"
                name="number"
                value={formData.number}
                onChange={handleInputChange}
                placeholder={L.form.number}
                className="w-full bg-white text-black px-4 py-3 rounded-xl outline-none"
              />
              <input
                type="text"
                name="subject"
                value={formData.subject}
                onChange={handleInputChange}
                placeholder={L.form.subject}
                className="w-full bg-white text-black px-4 py-3 rounded-xl outline-none"
                required
              />
              <textarea
                rows="5"
                name="msg"
                value={formData.msg}
                onChange={handleInputChange}
                placeholder={L.form.msg}
                className="w-full bg-white text-black px-4 py-3 rounded-xl outline-none"
                required
              />

              <button
                type="submit"
                className="mt-2 px-6 py-2 border border-cyan-500 text-cyan-500 rounded-full hover:bg-cyan-500 hover:text-white transition"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Sending..." : L.form.send}
              </button>
              {submitMessage && (
                <p className={`text-sm ${submitMessage.includes("success") ? "text-green-400" : "text-red-400"}`}>
                  {submitMessage}
                </p>
              )}
            </form>

            <div className="bg-gradient-to-b from-cyan-500 to-cyan-700 text-white p-6 md:p-8 rounded-xl shadow-lg">
              <h3 className={`${isMobile ? "text-lg" : "text-lg md:text-xl"} font-bold mb-2`}>{L.zoomTitle}</h3>
              <p className="text-sm md:text-base leading-relaxed mb-4">{L.zoomBody}</p>
              <a
                href="https://calendly.com/ibl-ai/zoom?month=2022-05"
                className="inline-block mt-2 px-4 py-2 bg-black text-white rounded-full hover:bg-white hover:text-black transition"
              >
                {L.zoomBtn}
              </a>
            </div>
          </div>
        </div>
      </section>

      <footer className="bg-black text-white px-6 md:px-20 py-10 text-sm">
        <div className={`max-w-7xl mx-auto flex ${isMobile ? "flex-col" : "flex-row"} justify-between items-center md:items-start gap-10`}>
          <div className={`flex flex-col ${isMobile ? "items-center" : "items-start"} text-center md:text-left`}>
            <p className="font-semibold text-2xl mb-2">{L.footerBrand}</p>
            <img src={spons} alt="IBL Reward" className="w-32 max-w-full self-center" />
          </div>

          <div className={`flex ${isMobile ? "justify-center" : ""} gap-4 ${isMobile ? "order-3" : ""}`}>
            <img src="https://img.icons8.com/ios-filled/50/ffffff/bank-card-back-side.png" className="h-10" alt="Card" />
            <img src="https://img.icons8.com/ios-filled/50/ffffff/mastercard-logo.png" className="h-10" alt="Mastercard" />
            <img src="https://img.icons8.com/ios-filled/50/ffffff/amex.png" className="h-10" alt="Amex" />
            <img src="https://img.icons8.com/ios-filled/50/ffffff/bitcoin.png" className="h-10" alt="Bitcoin" />
          </div>

          <div className={`leading-relaxed text-left text-sm ${isMobile ? "text-center" : ""}`}>
            <p className="font-semibold text-2xl mb-4">{L.footerContact}</p>

            <div className="flex items-start gap-2 mb-2">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-cyan-400 mt-[2px]" viewBox="0 0 20 20" fill="currentColor">
                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
              </svg>
              <span>{L.footerEmail}</span>
            </div>

            <div className="flex items-start gap-2 mb-2">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-cyan-400 mt-[2px]" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9l-4.95 4.95-4.95-4.95a7 7 0 010-9.9z" clipRule="evenodd" />
              </svg>
              <span>{L.footerAddr}</span>
            </div>

            <div className="flex items-start gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-cyan-400 mt-[2px]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 10h10m-10 4h6m-8 4h10a2 2 0 002-2v-8a2 2 0 00-2-2H6a2 2 0 00-2 2v8a2 2 0 002 2z" />
              </svg>
              <span>{L.footerHours}</span>
            </div>
          </div>
        </div>

        <div className="mt-10 text-center text-xs text-gray-500 border-t border-gray-700 pt-6">{L.copy}</div>
      </footer>
    </div>
  );
}
